import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resolveDefaultReturnUrl } from '../../helpers/appReturnUrl';
import { isAllowedReturnUrl } from '../../helpers/returnUrlValidator';

// Mirror the cap in queryParamHandler so a future caller that dispatches
// setAppName directly can't bypass the length check.
const MAX_APP_NAME_LENGTH = 64;

interface AppContextState {
  returnUrl: string;
  appName: string | null;
}

// Empty when neither the instance nor the app profile configures a target —
// STAppBar then renders no "Back to app" button. A runtime ?returnUrl= still
// overrides this via setReturnUrl.
const initialState: AppContextState = {
  returnUrl: resolveDefaultReturnUrl(),
  appName: null,
};

const appContextSlice = createSlice({
  name: 'appContext',
  initialState,
  reducers: {
    setReturnUrl: (state, action: PayloadAction<string>) => {
      // Defense-in-depth: validate at the reducer boundary so any future
      // caller (or accidental dispatch) can't bypass the allowlist and turn
      // the "Back to app" button into an open redirect.
      if (isAllowedReturnUrl(action.payload)) {
        state.returnUrl = action.payload;
      }
    },
    setAppName: (state, action: PayloadAction<string | null>) => {
      state.appName = action.payload
        ? action.payload.slice(0, MAX_APP_NAME_LENGTH)
        : null;
    },
  },
});

export const { setReturnUrl, setAppName } = appContextSlice.actions;
export default appContextSlice.reducer;
